// extracted by mini-css-extract-plugin
export var wrapper = "subscription-module--wrapper--yDG1r";
export var column = "subscription-module--column--EemZO";
export var title = "subscription-module--title--6V0xx";
export var description = "subscription-module--description--Oaq6Q";